import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';

const STATUS_VARIANTS = {
  ativo: { label: 'Ativo', variant: 'green' },
  encerrado: { label: 'Encerrado', variant: 'closed' },
  standby: { label: 'Stand-by', variant: 'standby' },
};

const ProgramCardsView = ({ data }) => {
  const items = data.items || [];
  const cols = data.columns || '2';
  return (
    <section className="ag-program-section">
      {data.eyebrow && (
        <span className="ag-program-section__eyebrow">{data.eyebrow}</span>
      )}
      {data.title && (
        <h2 className="ag-program-section__heading">{data.title}</h2>
      )}
      <div className="ag-program-grid" style={{ '--ag-cols': cols }}>
        {items.map((item, idx) => {
          const status = STATUS_VARIANTS[item.status] || STATUS_VARIANTS.ativo;
          const Card = (
            <article className={`ag-program-card ag-program-card--${status.variant}`}>
              <div className="ag-program-card__top">
                <div className="ag-program-card__acronym">{item.acronym || '—'}</div>
                <span className={`ag-status-pill ag-status-pill--${status.variant}`}>
                  <span className="ag-status-pill__dot" />
                  {status.label}
                </span>
              </div>
              <h3 className="ag-program-card__title">{item.title}</h3>
              {item.description && (
                <p className="ag-program-card__desc">{item.description}</p>
              )}
              {item.meta && (
                <div className="ag-program-card__meta">{item.meta}</div>
              )}
              {item.href && (
                <span className="ag-program-card__cta">Saiba mais →</span>
              )}
            </article>
          );
          return item.href ? (
            <UniversalLink key={idx} href={item.href} className="ag-program-card-link">
              {Card}
            </UniversalLink>
          ) : (
            <div key={idx} className="ag-program-card-link">{Card}</div>
          );
        })}
      </div>
    </section>
  );
};

ProgramCardsView.propTypes = {
  data: PropTypes.shape({
    eyebrow: PropTypes.string,
    title: PropTypes.string,
    columns: PropTypes.string,
    items: PropTypes.array,
  }).isRequired,
};
export default ProgramCardsView;
